module.exports = __webpack_public_path__ + "static/scale-model-of-wisconsin-veterans-museum-in-madison-wisconsin-1487de8eb914d141faf922417ca2a69d.png";